import { render, staticRenderFns } from "./money-reward.vue?vue&type=template&id=bbcb3a74&scoped=true&"
import script from "./money-reward.vue?vue&type=script&lang=js&"
export * from "./money-reward.vue?vue&type=script&lang=js&"
import style0 from "./money-reward.vue?vue&type=style&index=0&id=bbcb3a74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb3a74",
  null
  
)

export default component.exports